/** Display helpers for production-calendar pack-out freeze attribution from the API. */

export function formatSentToPackOutAtLabel(at: string | null | undefined): string | null {
  if (!at) return null;
  const parsed = new Date(at);
  if (Number.isNaN(parsed.getTime())) return at;
  return parsed.toLocaleString(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
  });
}

/** Turn `automatic:shipping-hub — Strict batch induction complete` into readable copy. */
export function formatAutomaticPackOutReason(reason: string): string {
  const trimmed = reason.trim();
  if (!trimmed.startsWith("automatic:")) return trimmed;
  const withoutPrefix = trimmed.slice("automatic:".length);
  const dashIndex = withoutPrefix.indexOf(" — ");
  const pageSlug = (dashIndex >= 0 ? withoutPrefix.slice(0, dashIndex) : withoutPrefix).trim();
  const detail = dashIndex >= 0 ? withoutPrefix.slice(dashIndex + 3).trim() : "";
  const pageLabel = pageSlug.replace(/-/g, " ");
  if (!detail) return `Automatic (${pageLabel})`;
  return `Automatic (${pageLabel}) — ${detail}`;
}

export function formatSentToPackOutAttributionSummary(input: {
  sentToPackOutAt: string | null;
  sentToPackOutByLabel: string | null;
  sentToPackOutReason: string | null;
}): string | null {
  const parts: string[] = [];
  const when = formatSentToPackOutAtLabel(input.sentToPackOutAt);
  if (when) parts.push(when);

  const reason = input.sentToPackOutReason?.trim() ?? "";
  if (reason.startsWith("automatic:")) {
    parts.push(formatAutomaticPackOutReason(reason));
  } else {
    if (input.sentToPackOutByLabel) parts.push(input.sentToPackOutByLabel);
    if (reason) parts.push(reason);
  }

  return parts.length > 0 ? parts.join(" · ") : null;
}
